import { render, staticRenderFns } from "./Uporabniki.vue?vue&type=template&id=13ccfd1c&scoped=true"
import script from "./Uporabniki.vue?vue&type=script&lang=js"
export * from "./Uporabniki.vue?vue&type=script&lang=js"
import style0 from "./Uporabniki.vue?vue&type=style&index=0&id=13ccfd1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ccfd1c",
  null
  
)

export default component.exports